'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const EditIcon = createIcon({
    displayName: 'EditIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M11.667 7.067L9 4.4M1.333 14.733l2.257-.25c.275-.031.413-.046.542-.088.114-.037.223-.09.323-.155.113-.075.212-.173.408-.37l8.804-8.803A1.886 1.886 0 1011 2.4l-8.804 8.804c-.196.196-.294.294-.369.407-.066.1-.118.21-.155.324-.042.128-.057.266-.088.542l-.25 2.256z"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default EditIcon
